import React from "react";
import { Switch, Redirect, Route } from "react-router-dom";

import { clientUrls } from "misc/urls";

import RolesListComponent from "./components/RolesListComponent";
import RoleComponent from "./components/RoleComponent";
import { usePermittedHierarchy } from "misc/api/datalayer";
import { useRoles } from "misc/api/keycloakApi";

const RolesContainer = () => {
    // Prefetching
    usePermittedHierarchy({ suspense: true });
    useRoles({ suspense: true });

    return (
        <Switch>
            <Route exact path={clientUrls.roles.baseUrl()} component={RolesListComponent} />
            <Route exact path={clientUrls.roles.edit()} component={RoleComponent} />
            <Route exact path={clientUrls.roles.create()} component={RoleComponent} />
            <Redirect to={clientUrls.roles.baseUrl()} />
        </Switch>
    );
};

export default RolesContainer;
